module.exports = __webpack_public_path__ + "img/shape-metal_ay_mobile@2x.e8b2416b.png";